import React from 'react';
import PropTypes from 'prop-types';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

import { componentIdStringGenerator } from '../../../helpers';

const DialogTitle = (props) => {
  return (
    <MuiDialogTitle
      {...props}
      id={componentIdStringGenerator('DialogTitle', props.id ? props.id : props.children)}
    />
  );
};

DialogTitle.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
};

export default DialogTitle;
